import React, { useState, useMemo, useEffect } from "react";
import FullUserProfileComponent from "../SellerProfile/FullUserProfileComponent";
import Tabs from "../../UILibrary/Tabs";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ChartDashboard from "./ChartDashboard";
import TransactionsTable from "./TransactionsTable";
import ScoreCardDashboard from "./ScoreCardDashboard";
import { getMonthlyTransactionData, getLastThreeMonthsTransactionData, getYearlyTransactionData, getAllTransactions } from "../../../store/engagementMetricsSlice";
import AddFinancialDataModal from "./AddFinancialDataModal";



const SupplierEngagement = () => {
  const [selectedTab, setSelectedTab] = useState(() => {
    return localStorage.getItem("selectedTab") || "Supplier profile";
  });
  const dispatch = useDispatch();
  const tabs = ["Supplier profile", "Supplier engagement"];
  const engagementTabs = ["Spend Tracker", "Score card"];
  const [isEngagementTab, setEngagementTab] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Monthly");
  const [previousBudgetData, setPreviousBudgetData] = useState([]);
  const [previousSpendData, setPreviousSpendData] = useState([]);
  const [previousTransactionsData, setPreviousTransactionsData] = useState([]);
  const [selectedEngagementTab, setSelectedEngagementTab] =
    useState("Spend Tracker");
    const user = useSelector((state) => state.auth.userDetails.userDetails);
    const userId = useSelector((state) => state.auth.id);
    const supplier = useSelector((state) => state.auth.selectedSupplier);

  useEffect(() => {
    localStorage.setItem("selectedTab", selectedTab);
  }, [selectedTab]);
    const { selectedPeriod, totalBudget, totalSpend } = useSelector(
    (state) => state.engagementMetrics
  );
useEffect(() => {
  const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;
  if (selectedFilter === "Monthly") {
    dispatch(getMonthlyTransactionData({supplierId: supplier._id, buyerId: buyerIdToUse}));
  } else if (selectedFilter === "Last 3 Months") {
    dispatch(getLastThreeMonthsTransactionData({supplierId: supplier._id, buyerId: buyerIdToUse}));
  } else if (selectedFilter === "Yearly") {
    dispatch(getYearlyTransactionData({supplierId: supplier._id, buyerId: buyerIdToUse}));
  }
  dispatch(getAllTransactions({supplierId: supplier._id, buyerId: buyerIdToUse}))
}, [dispatch, selectedFilter]);


  useEffect(() => {
    const currentTab = localStorage.getItem("selectedTab", selectedTab);
    if (currentTab === "Supplier engagement") setEngagementTab(true);
  }, [selectedTab]);


useEffect(() => {

}, [totalSpend]);


  
  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
  };
 
  

  const navigate = useNavigate();
  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
      onClick={onClick}
      ref={ref}
      className="flex items-center gap-2 border border-[#D6D6D6] rounded px-3 py-1.5 bg-white shadow-sm text-sm text-gray-800"
    >
      <span>{value || "Jan 2025 - Mar 2025"}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M5 22.333C4.45 22.333 3.97917 22.1372 3.5875 21.7455C3.19583 21.3538 3 20.883 3 20.333V6.33301C3 5.78301 3.19583 5.31217 3.5875 4.92051C3.97917 4.52884 4.45 4.33301 5 4.33301H6V2.33301H8V4.33301H16V2.33301H18V4.33301H19C19.55 4.33301 20.0208 4.52884 20.4125 4.92051C20.8042 5.31217 21 5.78301 21 6.33301V20.333C21 20.883 20.8042 21.3538 20.4125 21.7455C20.0208 22.1372 19.55 22.333 19 22.333H5ZM5 20.333H19V10.333H5V20.333ZM5 8.33301H19V6.33301H5V8.33301ZM12 14.333C11.7167 14.333 11.4792 14.2372 11.2875 14.0455C11.0958 13.8538 11 13.6163 11 13.333C11 13.0497 11.0958 12.8122 11.2875 12.6205C11.4792 12.4288 11.7167 12.333 12 12.333C12.2833 12.333 12.5208 12.4288 12.7125 12.6205C12.9042 12.8122 13 13.0497 13 13.333C13 13.6163 12.9042 13.8538 12.7125 14.0455C12.5208 14.2372 12.2833 14.333 12 14.333ZM8 14.333C7.71667 14.333 7.47917 14.2372 7.2875 14.0455C7.09583 13.8538 7 13.6163 7 13.333C7 13.0497 7.09583 12.8122 7.2875 12.6205C7.47917 12.4288 7.71667 12.333 8 12.333C8.28333 12.333 8.52083 12.4288 8.7125 12.6205C8.90417 12.8122 9 13.0497 9 13.333C9 13.6163 8.90417 13.8538 8.7125 14.0455C8.52083 14.2372 8.28333 14.333 8 14.333ZM16 14.333C15.7167 14.333 15.4792 14.2372 15.2875 14.0455C15.0958 13.8538 15 13.6163 15 13.333C15 13.0497 15.0958 12.8122 15.2875 12.6205C15.4792 12.4288 15.7167 12.333 16 12.333C16.2833 12.333 16.5208 12.4288 16.7125 12.6205C16.9042 12.8122 17 13.0497 17 13.333C17 13.6163 16.9042 13.8538 16.7125 14.0455C16.5208 14.2372 16.2833 14.333 16 14.333ZM12 18.333C11.7167 18.333 11.4792 18.2372 11.2875 18.0455C11.0958 17.8538 11 17.6163 11 17.333C11 17.0497 11.0958 16.8122 11.2875 16.6205C11.4792 16.4288 11.7167 16.333 12 16.333C12.2833 16.333 12.5208 16.4288 12.7125 16.6205C12.9042 16.8122 13 17.0497 13 17.333C13 17.6163 12.9042 17.8538 12.7125 18.0455C12.5208 18.2372 12.2833 18.333 12 18.333ZM8 18.333C7.71667 18.333 7.47917 18.2372 7.2875 18.0455C7.09583 17.8538 7 17.6163 7 17.333C7 17.0497 7.09583 16.8122 7.2875 16.6205C7.47917 16.4288 7.71667 16.333 8 16.333C8.28333 16.333 8.52083 16.4288 8.7125 16.6205C8.90417 16.8122 9 17.0497 9 17.333C9 17.6163 8.90417 17.8538 8.7125 18.0455C8.52083 18.2372 8.28333 18.333 8 18.333ZM16 18.333C15.7167 18.333 15.4792 18.2372 15.2875 18.0455C15.0958 17.8538 15 17.6163 15 17.333C15 17.0497 15.0958 16.8122 15.2875 16.6205C15.4792 16.4288 15.7167 16.333 16 16.333C16.2833 16.333 16.5208 16.4288 16.7125 16.6205C16.9042 16.8122 17 17.0497 17 17.333C17 17.6163 16.9042 17.8538 16.7125 18.0455C16.5208 18.2372 16.2833 18.333 16 18.333Z"
          fill="#1D2739"
        />
      </svg>
    </button>
  ));
  CustomDateInput.displayName = "CustomDateInput";

  const handleGoBack = () => {
    navigate("/dashboard/management");
    localStorage.removeItem("selectedTab");
  };

  return (
    <div className="p-6 mb-36">
      <Tabs
        title="Supplier Management"
        tabs={tabs}
        mngmtSelectedTab={selectedTab}
        supplier={supplier}
        onTabChange={handleTabClick}
        handleGoBack={handleGoBack}
        management={true}
        engagementTabs={engagementTabs}
        isEngagementTab={isEngagementTab}
        setEngagementTab={setEngagementTab}
        selectedEngagementTab={selectedEngagementTab}
        setSelectedEngagementTab={setSelectedEngagementTab}
      />

      {selectedTab === "Supplier profile" ? (
        <FullUserProfileComponent
          backUrl="/dashboard/management"
          management={true}
        />
      ) : selectedEngagementTab === "Spend Tracker" ? (
        <>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end mt-6 gap-4 sm:gap-0">
            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 w-full sm:w-auto justify-center">
              <div className="flex gap-2 bg-white rounded-xl p-1 shadow justify-center">
                {["Monthly", "Last 3 Months", "Yearly"].map((filter, index) => (
                  <button
                    key={filter}
                    className={`px-4 py-1 whitespace-nowrap ${
                      index < 2 ? "border-r" : ""
                    } ${
                      selectedFilter === filter
                        ? "text-blue-600 font-semibold"
                        : "text-gray-600 hover:text-gray-400"
                    }`}
                    onClick={() => handleFilterClick(filter)}
                    type="button"
                  >
                    {filter}
                  </button>
                ))}
              </div>

              <button
                type="submit"
                onClick={() => setModalOpen(true)}
                className="inline-flex h-[40px] px-4 py-[6px] justify-start items-center opacity-90 bg-[#EAF524] rounded-lg text-black font-semibold border-0 whitespace-nowrap"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M12.1851 6.5V18.5M18.1851 12.5H6.18506"
                    stroke="#1D2739"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                Add Financial Data
              </button>
            </div>
          </div>

          <AddFinancialDataModal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            totalSpend={totalSpend}
            previousTransactionsData={previousTransactionsData}
            setPreviousBudgetData={setPreviousBudgetData}
            setPreviousSpendData={setPreviousSpendData}
            setPreviousTransactionsData={setPreviousTransactionsData}
          />
          <div className="flex flex-col md:flex-row gap-6 justify-start mt-6 mb-6">
            <div className="flex flex-col p-6 rounded-2xl border border-gray-200 bg-white w-full max-w-md shadow-sm">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-gray-100 p-2 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M13.9993 10.667C13.4741 10.667 12.9539 10.7705 12.4686 10.9715C11.9833 11.1725 11.5424 11.4671 11.1709 11.8386C10.7995 12.21 10.5048 12.651 10.3038 13.1363C10.1028 13.6216 9.99935 14.1417 9.99935 14.667C9.99935 15.1923 10.1028 15.7124 10.3038 16.1977C10.5048 16.683 10.7995 17.124 11.1709 17.4954C11.5424 17.8669 11.9833 18.1615 12.4686 18.3625C12.9539 18.5635 13.4741 18.667 13.9993 18.667C15.0602 18.667 16.0776 18.2456 16.8278 17.4954C17.5779 16.7453 17.9993 15.7279 17.9993 14.667C17.9993 13.6061 17.5779 12.5887 16.8278 11.8386C16.0776 11.0884 15.0602 10.667 13.9993 10.667ZM11.9993 14.667C11.9993 14.1366 12.2101 13.6279 12.5851 13.2528C12.9602 12.8777 13.4689 12.667 13.9993 12.667C14.5298 12.667 15.0385 12.8777 15.4136 13.2528C15.7886 13.6279 15.9993 14.1366 15.9993 14.667C15.9993 15.1974 15.7886 15.7061 15.4136 16.0812C15.0385 16.4563 14.5298 16.667 13.9993 16.667C13.4689 16.667 12.9602 16.4563 12.5851 16.0812C12.2101 15.7061 11.9993 15.1974 11.9993 14.667ZM2.66602 9.66699C2.66602 8.87134 2.98209 8.10828 3.5447 7.54567C4.1073 6.98306 4.87037 6.66699 5.66602 6.66699H22.3327C22.7266 6.66699 23.1168 6.74459 23.4807 6.89535C23.8447 7.04612 24.1754 7.2671 24.454 7.54567C24.7326 7.82425 24.9536 8.15497 25.1043 8.51894C25.2551 8.88292 25.3327 9.27303 25.3327 9.66699V19.667C25.3327 20.061 25.2551 20.4511 25.1043 20.815C24.9536 21.179 24.7326 21.5097 24.454 21.7883C24.1754 22.0669 23.8447 22.2879 23.4807 22.4386C23.1168 22.5894 22.7266 22.667 22.3327 22.667H5.66602C4.87037 22.667 4.1073 22.3509 3.5447 21.7883C2.98209 21.2257 2.66602 20.4626 2.66602 19.667V9.66699ZM5.66602 8.66699C5.4008 8.66699 5.14645 8.77235 4.95891 8.95989C4.77137 9.14742 4.66602 9.40178 4.66602 9.66699V10.667H5.66602C5.93123 10.667 6.18559 10.5616 6.37312 10.3741C6.56066 10.1866 6.66602 9.93221 6.66602 9.66699V8.66699H5.66602ZM4.66602 16.667H5.66602C6.46166 16.667 7.22473 16.9831 7.78734 17.5457C8.34994 18.1083 8.66602 18.8713 8.66602 19.667V20.667H19.3327V19.667C19.3327 18.8713 19.6488 18.1083 20.2114 17.5457C20.774 16.9831 21.537 16.667 22.3327 16.667H23.3327V12.667H22.3327C21.537 12.667 20.774 12.3509 20.2114 11.7883C19.6488 11.2257 19.3327 10.4626 19.3327 9.66699V8.66699H8.66602V9.66699C8.66602 10.061 8.58842 10.4511 8.43765 10.815C8.28689 11.179 8.06591 11.5097 7.78734 11.7883C7.50876 12.0669 7.17804 12.2879 6.81407 12.4386C6.45009 12.5894 6.05998 12.667 5.66602 12.667H4.66602V16.667ZM23.3327 10.667V9.66699C23.3327 9.40178 23.2273 9.14742 23.0398 8.95989C22.8523 8.77235 22.5979 8.66699 22.3327 8.66699H21.3327V9.66699C21.3327 10.219 21.7807 10.667 22.3327 10.667H23.3327ZM23.3327 18.667H22.3327C22.0675 18.667 21.8131 18.7724 21.6256 18.9599C21.438 19.1474 21.3327 19.4018 21.3327 19.667V20.667H22.3327C22.5979 20.667 22.8523 20.5616 23.0398 20.3741C23.2273 20.1866 23.3327 19.9322 23.3327 19.667V18.667ZM4.66602 19.667C4.66602 20.219 5.11402 20.667 5.66602 20.667H6.66602V19.667C6.66602 19.4018 6.56066 19.1474 6.37312 18.9599C6.18559 18.7724 5.93123 18.667 5.66602 18.667H4.66602V19.667ZM5.86735 24.667C6.21842 25.2753 6.72355 25.7805 7.33188 26.1316C7.94022 26.4827 8.6303 26.6673 9.33268 26.667H22.9993C23.8311 26.667 24.6546 26.5032 25.423 26.1849C26.1914 25.8666 26.8896 25.4001 27.4777 24.812C28.0658 24.2239 28.5323 23.5257 28.8506 22.7573C29.1689 21.9889 29.3327 21.1654 29.3327 20.3337V13.3337C29.3329 12.6313 29.1482 11.9413 28.7971 11.333C28.446 10.7246 27.9409 10.2195 27.3327 9.86833V20.3337C27.3327 21.4829 26.8761 22.5851 26.0635 23.3978C25.2508 24.2104 24.1486 24.667 22.9993 24.667H5.86735Z"
                      fill="#656565"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-800 text-left">
                    Total Budget
                  </h3>
                  <p className="text-sm text-gray-500">{selectedPeriod}</p>
                </div>
              </div>
              <div className="text-3xl font-semibold text-gray-900 text-left">
                $ {totalBudget.toLocaleString()}
              </div>
            </div>
            <div className="flex flex-col p-6 rounded-2xl border border-gray-200 bg-white w-full max-w-md shadow-sm">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-gray-100 p-2 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M13.9993 10.667C13.4741 10.667 12.9539 10.7705 12.4686 10.9715C11.9833 11.1725 11.5424 11.4671 11.1709 11.8386C10.7995 12.21 10.5048 12.651 10.3038 13.1363C10.1028 13.6216 9.99935 14.1417 9.99935 14.667C9.99935 15.1923 10.1028 15.7124 10.3038 16.1977C10.5048 16.683 10.7995 17.124 11.1709 17.4954C11.5424 17.8669 11.9833 18.1615 12.4686 18.3625C12.9539 18.5635 13.4741 18.667 13.9993 18.667C15.0602 18.667 16.0776 18.2456 16.8278 17.4954C17.5779 16.7453 17.9993 15.7279 17.9993 14.667C17.9993 13.6061 17.5779 12.5887 16.8278 11.8386C16.0776 11.0884 15.0602 10.667 13.9993 10.667ZM11.9993 14.667C11.9993 14.1366 12.2101 13.6279 12.5851 13.2528C12.9602 12.8777 13.4689 12.667 13.9993 12.667C14.5298 12.667 15.0385 12.8777 15.4136 13.2528C15.7886 13.6279 15.9993 14.1366 15.9993 14.667C15.9993 15.1974 15.7886 15.7061 15.4136 16.0812C15.0385 16.4563 14.5298 16.667 13.9993 16.667C13.4689 16.667 12.9602 16.4563 12.5851 16.0812C12.2101 15.7061 11.9993 15.1974 11.9993 14.667ZM2.66602 9.66699C2.66602 8.87134 2.98209 8.10828 3.5447 7.54567C4.1073 6.98306 4.87037 6.66699 5.66602 6.66699H22.3327C22.7266 6.66699 23.1168 6.74459 23.4807 6.89535C23.8447 7.04612 24.1754 7.2671 24.454 7.54567C24.7326 7.82425 24.9536 8.15497 25.1043 8.51894C25.2551 8.88292 25.3327 9.27303 25.3327 9.66699V19.667C25.3327 20.061 25.2551 20.4511 25.1043 20.815C24.9536 21.179 24.7326 21.5097 24.454 21.7883C24.1754 22.0669 23.8447 22.2879 23.4807 22.4386C23.1168 22.5894 22.7266 22.667 22.3327 22.667H5.66602C4.87037 22.667 4.1073 22.3509 3.5447 21.7883C2.98209 21.2257 2.66602 20.4626 2.66602 19.667V9.66699ZM5.66602 8.66699C5.4008 8.66699 5.14645 8.77235 4.95891 8.95989C4.77137 9.14742 4.66602 9.40178 4.66602 9.66699V10.667H5.66602C5.93123 10.667 6.18559 10.5616 6.37312 10.3741C6.56066 10.1866 6.66602 9.93221 6.66602 9.66699V8.66699H5.66602ZM4.66602 16.667H5.66602C6.46166 16.667 7.22473 16.9831 7.78734 17.5457C8.34994 18.1083 8.66602 18.8713 8.66602 19.667V20.667H19.3327V19.667C19.3327 18.8713 19.6488 18.1083 20.2114 17.5457C20.774 16.9831 21.537 16.667 22.3327 16.667H23.3327V12.667H22.3327C21.537 12.667 20.774 12.3509 20.2114 11.7883C19.6488 11.2257 19.3327 10.4626 19.3327 9.66699V8.66699H8.66602V9.66699C8.66602 10.061 8.58842 10.4511 8.43765 10.815C8.28689 11.179 8.06591 11.5097 7.78734 11.7883C7.50876 12.0669 7.17804 12.2879 6.81407 12.4386C6.45009 12.5894 6.05998 12.667 5.66602 12.667H4.66602V16.667ZM23.3327 10.667V9.66699C23.3327 9.40178 23.2273 9.14742 23.0398 8.95989C22.8523 8.77235 22.5979 8.66699 22.3327 8.66699H21.3327V9.66699C21.3327 10.219 21.7807 10.667 22.3327 10.667H23.3327ZM23.3327 18.667H22.3327C22.0675 18.667 21.8131 18.7724 21.6256 18.9599C21.438 19.1474 21.3327 19.4018 21.3327 19.667V20.667H22.3327C22.5979 20.667 22.8523 20.5616 23.0398 20.3741C23.2273 20.1866 23.3327 19.9322 23.3327 19.667V18.667ZM4.66602 19.667C4.66602 20.219 5.11402 20.667 5.66602 20.667H6.66602V19.667C6.66602 19.4018 6.56066 19.1474 6.37312 18.9599C6.18559 18.7724 5.93123 18.667 5.66602 18.667H4.66602V19.667ZM5.86735 24.667C6.21842 25.2753 6.72355 25.7805 7.33188 26.1316C7.94022 26.4827 8.6303 26.6673 9.33268 26.667H22.9993C23.8311 26.667 24.6546 26.5032 25.423 26.1849C26.1914 25.8666 26.8896 25.4001 27.4777 24.812C28.0658 24.2239 28.5323 23.5257 28.8506 22.7573C29.1689 21.9889 29.3327 21.1654 29.3327 20.3337V13.3337C29.3329 12.6313 29.1482 11.9413 28.7971 11.333C28.446 10.7246 27.9409 10.2195 27.3327 9.86833V20.3337C27.3327 21.4829 26.8761 22.5851 26.0635 23.3978C25.2508 24.2104 24.1486 24.667 22.9993 24.667H5.86735Z"
                      fill="#656565"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-800 text-left">
                    Spend on Supplier
                  </h3>
                  <p className="text-sm text-gray-500 text-left">
                    {supplier?.company.name}
                  </p>
                </div>
              </div>
              <div className="text-3xl font-semibold text-gray-900 text-left">
                $ {totalSpend.toLocaleString()}
              </div>
            </div>
          </div>

          <ChartDashboard
            filter={selectedFilter}
          />
          <TransactionsTable
            previousTransactionsData={previousTransactionsData}
            setPreviousTransactionsData={setPreviousTransactionsData}
            setPreviousSpendData={setPreviousSpendData}
            previousSpendData={previousSpendData}
            filter={selectedFilter}
          />
        </>
      ) : selectedEngagementTab === "Score card" ? (
        <ScoreCardDashboard />
      ) : null}
    </div>
  );
};

export default SupplierEngagement;
